export default "/images/vendor/flag-icons/flags/1x1/lv.svg?884e7f97a321e3dda41076bbaef04f81";